import { applyStandardFeaturesText } from './standardFeaturesText'

export default (state, { type, load }) => {
	switch (type) {
		case 'UPDATE ROOT':
			return { ...state, root: load }
		case 'UPDATE MESSAGE':
			return { ...state, message: load }
		case 'UPDATE MESSAGE VARIABLES':
			return { ...state, messageVariables: load }
		case 'UPDATE SELECTED VIEW':
			return { ...state, selectedView: load }
		case 'UPDATE CURRENT COMPONENT PATH':
			return { ...state, currentComponentPath: load }
		case 'UPDATE ACTIVE KEY':
			return { ...state, activeKey: load }
		case 'SHOW SUPPORTED LANGUAGES MODAL':
			return { ...state, supportedLanguagesModalVisible: true, supportedLanguagesMissing: load }
		case 'HIDE SUPPORTED LANGUAGES MODAL':
			return { ...state, supportedLanguagesModalVisible: false, supportedLanguagesMissing: [] }
		case 'UPDATE PRIVACY COMPLIANCE STATUS':
			return { ...state, privacyComplianceStatus: load }
		case 'SHOW COMPLETE CHECK PRIVACY MODAL':
			return { ...state, showCompleteCheckPrivacyModal: load }
		case 'UPDATE CURRENT COMPONENT PATH':
			return { ...state, currentComponentPath: load }
		case 'CONFIRM PRIVACY CHECK':
		case 'UPDATE SETTING':
		case 'UPDATE VIEW':
			return { ...state, ...load }
		case 'UPDATE_TEMPLATE_PARAMS':
			return {
				...state,
				templateParams: load,
				chooseTemplateTypeModalVisible: false,
			}
		case 'SHOW_CHOOSE_TEMPLATE_MODAL_VISIBLE':
			return { ...state, chooseTemplateTypeModalVisible: load }
		case 'UPDATE_TEMPLATE_NAME':
			return {
				...state,
				templateParams: {
					...state.templateParams,
					name: load
				}
			}
		case 'UPDATE PM DATA':
			return { ...state, pmData: load }
		case 'APPLY STANDARD FEATURES TEXT': {
			// load: { vendorListId, texts: { [language]: text | null } }
			// Applied against current state because the iframe listener closes over the initial message.
			// Responses for a vendor list that is no longer selected are dropped.
			const { vendorList, defaultLanguage } = state.root.settings
			if (load.vendorListId !== vendorList) return state
			const texts = state.standardFeaturesText.vendorListId === vendorList
				? { ...state.standardFeaturesText.texts, ...load.texts }
				: { ...load.texts }
			const message = applyStandardFeaturesText(state.message, texts, defaultLanguage)
			return {
				...state,
				standardFeaturesText: { vendorListId: vendorList, texts },
				message: message || state.message,
			}
		}
		case 'UPDATE SELECTED VENDOR':
			return { ...state, selectedVendorIndex: load }
		default:
			throw Error(`Bad action type: ${type}`)
	}
}